// extracted by mini-css-extract-plugin
export default {"HeroBanner":"HeroBanner_HeroBanner__OpbS9","sectionTitle":"HeroBanner_sectionTitle__WfTZz","titleText":"HeroBanner_titleText__yyblj","subtitleText":"HeroBanner_subtitleText__Npln3"};